// components/profile/ProfileForm.js
import { useState, useEffect } from "react";
import {
    getCurrentUser,
    updateProfile,
    changePassword,
} from "../../../services/userService";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

export default function ProfileForm() {
    // State lưu thông tin user hiện tại
    const [user, setUser] = useState(null);

    // State cho trường tên khi chỉnh sửa
    const [name, setName] = useState("");

    // State hiển thị thông báo khi cập nhật thông tin cá nhân
    const [message, setMessage] = useState("");

    // State hiển thị thông báo khi đổi mật khẩu
    const [passwordMessage, setPasswordMessage] = useState("");

    // State lưu dữ liệu khi đổi mật khẩu
    const [passwordData, setPasswordData] = useState({
        currentPassword: "",
        newPassword: "",
    });

    // State kiểm soát việc hiển thị/ẩn mật khẩu
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
    });

    // useEffect chạy 1 lần khi component mount để lấy thông tin user
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const data = await getCurrentUser();
                setUser(data);
                setName(data.name);
            } catch (error) {
                console.error("Lỗi khi lấy thông tin người dùng:", error);
            }
        };

        fetchUser();
    }, []);

    // Hàm xử lý cập nhật thông tin cá nhân
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        try {
            const res = await updateProfile({ name });
            setMessage("Cập nhật thành công!");
            setUser(res.user);
        } catch (error) {
            console.error("Lỗi khi cập nhật thông tin:", error);
            setMessage("Cập nhật thất bại.");
        }
    };

    // Hàm xử lý đổi mật khẩu
    const handleChangePassword = async (e) => {
        e.preventDefault();
        try {
            await changePassword(passwordData);
            setPasswordMessage("Đổi mật khẩu thành công!");
            setPasswordData({ currentPassword: "", newPassword: "" });
        } catch (error) {
            console.error("Lỗi khi đổi mật khẩu:", error);
            setPasswordMessage("Đổi mật khẩu thất bại.");
        }
    };

    // Hàm toggle ẩn/hiện mật khẩu theo field ("current" hoặc "new")
    const toggleShowPassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    // Nếu chưa có dữ liệu user thì hiển thị loading
    if (!user) return <div>Loading...</div>;

    return (
        <div className="max-w-2xl mx-auto py-10 px-4">
            <h1 className="text-2xl font-bold mb-6">Thông tin cá nhân</h1>

            <form onSubmit={handleUpdateProfile} className="space-y-4 mb-8">
                <div>
                    <label className="block mb-1 font-medium">Email:</label>
                    <input
                        type="email"
                        value={user.email}
                        disabled
                        className="w-full border px-3 py-2 bg-gray-100"
                    />
                </div>

                <div>
                    <label className="block mb-1 font-medium">Tên:</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full border px-3 py-2"
                    />
                </div>

                <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Cập nhật thông tin
                </button>

                {message && <p className="text-green-600">{message}</p>}
            </form>

            <h2 className="text-xl font-semibold mb-4">Đổi mật khẩu</h2>

            <form onSubmit={handleChangePassword} className="space-y-4">
                <div className="relative">
                    <label className="block mb-1 font-medium">Mật khẩu hiện tại:</label>
                    <input
                        type={showPassword.current ? "text" : "password"}
                        value={passwordData.currentPassword}
                        onChange={(e) =>
                            setPasswordData({
                                ...passwordData,
                                currentPassword: e.target.value,
                            })
                        }
                        className="w-full border px-3 py-2 pr-10"
                        required
                    />
                    <span
                        onClick={() => toggleShowPassword("current")}
                        className="absolute right-3 top-9 cursor-pointer text-gray-500"
                    >
                        {showPassword.current ? (
                            <AiFillEyeInvisible size={20} />
                        ) : (
                            <AiFillEye size={20} />
                        )}
                    </span>
                </div>

                <div className="relative">
                    <label className="block mb-1 font-medium">Mật khẩu mới:</label>
                    <input
                        type={showPassword.new ? "text" : "password"}
                        value={passwordData.newPassword}
                        onChange={(e) =>
                            setPasswordData({
                                ...passwordData,
                                newPassword: e.target.value,
                            })
                        }
                        className="w-full border px-3 py-2 pr-10"
                        required
                    />
                    <span
                        onClick={() => toggleShowPassword("new")}
                        className="absolute right-3 top-9 cursor-pointer text-gray-500"
                    >
                        {showPassword.new ? (
                            <AiFillEyeInvisible size={20} />
                        ) : (
                            <AiFillEye size={20} />
                        )}
                    </span>
                </div>

                <button
                    type="submit"
                    className="bg-green-600 text-white px-4 py-2 rounded"
                >
                    Đổi mật khẩu
                </button>

                {passwordMessage && (
                    <p className="text-green-600">{passwordMessage}</p>
                )}
            </form>
        </div>
    );
}
